
import { motion } from "framer-motion";
import { fadeInVariants } from "@/lib/animations";

interface SectionPlaceholderProps {
  bg: string;
  height: string;
}

const SectionPlaceholder = ({ bg, height }: SectionPlaceholderProps) => (
  <motion.div 
    className={`py-16 ${bg} relative ${height}`}
    initial="initial"
    animate="animate"
    variants={fadeInVariants}
  >
    <div className="container mx-auto px-4 text-center">
      <motion.div 
        className="w-12 h-12 mx-auto mb-4 rounded-full bg-brand-blue/20"
        animate={{
          scale: [1, 1.2, 1],
          opacity: [0.7, 1, 0.7]
        }}
        transition={{
          duration: 1.5,
          repeat: Infinity,
          ease: "easeInOut"
        }}
      />
      <motion.div 
        className="h-4 w-48 mx-auto bg-gray-200 rounded"
        animate={{
          opacity: [0.7, 0.5, 0.7]
        }}
        transition={{
          duration: 1.8,
          repeat: Infinity,
          ease: "easeInOut"
        }}
      />
    </div>
  </motion.div>
);

export default SectionPlaceholder;
